import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_93: FaireProductEntity = {
  token: "catalog_prod_prod-93",
  type: "product",
  name: "Tabletop Accessory",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  priceDollars: 62.73,
  msrpDollars: 156.82,
  sku: "CA0093",
  caseSize: 1,
  material: "Ceramic",
  collectionToken: "col_camp",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 488,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_mens-accessories"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
